import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import backgroundImage from 'assets/Mountain-bg.png';

// import Sidebar from 'components/common/Sidebar/Sidebar';
import TSNavbar from 'components/common/Navbar/TSNavBar';

const DashboardLayout = () => {
  const isNonMobile = useMediaQuery('(min-width: 600px)');
  const { pathname } = useLocation();

  const myStyle = {
    bg: {
      backgroundImage: `url(${backgroundImage})`, // Use template literal or concatenation
      height: '100vh', // Example: set height to cover the viewport
      backgroundSize: 'cover', // Example: cover the entire element
      backgroundRepeat: 'no-repeat', // Example: prevent image from repeating
    },
    content: {
      height: '100%',
      width: '100%',
      backgroundColor: 'rgba(253, 253, 253, 0.75)',
    },
  };

  return (
    <>
      <div className="flex items-start h-full overflow-auto">
        <div
          className="flex-1 h-full w-[calc(100%_-_260px)] bg-[var(--ts-bg)]"
          // style={myStyle.bg}
        >
          <div className="max-w-[1600px] mx-auto" style={myStyle.content}>
            <TSNavbar />
            <div>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
